import React from 'react';
import { Wordmark } from './Wordmark';
import { PHONE_DISPLAY, PHONE_HREF } from './CtaButton';
export function FinePrint() {
  return <footer className="bg-brand-white" data-id="element-27" data-mp="w4fsqckdyne1">
      <div className="mx-auto max-w-6xl px-5 py-12 sm:px-8 sm:py-14" data-id="element-28" data-mp="hdyq4pw0lrfk">
        <div className="flex flex-col gap-6 border-t border-brand-light pt-10 sm:flex-row sm:items-start sm:justify-between" data-id="element-29" data-mp="hbvt3lwg2y1c">
          <Wordmark data-id="element-30" data-mp="1a2mgv0zj990i" />
          <a href={PHONE_HREF} className="font-display text-lg font-bold transition-colors duration-150 ease-out hover:text-brand-red focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-red" data-id="element-31" data-mp="1a2cs1gq857we">
            {PHONE_DISPLAY}
          </a>
        </div>

        <p className="mt-8 max-w-4xl text-[11px] leading-relaxed text-brand-gray" data-id="element-32" data-mp="151ylk349u60h">
          $997 is the standard White Glove Onboarding price on every package. This offer applies to
          new Launch and Pilot sign-ups only, for a limited time. 72-hour timeline refers to the
          initial site shell being built and live; final content updates and revisions continue
          afterward through Slack. 3-month minimum term applies to all packages. Additional websites
          billed separately. Prices shown include standard card processing.
        </p>

        <p className="mt-6 text-[11px] text-brand-gray" data-id="element-33" data-mp="1p7hxbhntgi6">
          © {new Date().getFullYear()} Ad ROI Marketing &amp; Conversions · results@getadroi.com
        </p>
      </div>
    </footer>;
}